// @ts-nocheck
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Storage from '@/utils/storage';

const getPageFilters = async (section: any) => {
    return await getSettings(section, Enums.ConfigurationType.PageFilters);
};

const getCrudSettings = async (section: any) => {
    return await getSettings(section, Enums.ConfigurationType.CRUD);
}

const getSettings = async (section: any, type: any) => {
    let configResponse = await Fetch.get({
        url: '/AuthUserConfiguration',
        params: {
            type: type,
            section: section
        }
    });


    return configResponse.Results && configResponse.Results.length > 0 ? configResponse.Results[0] : {
        AuthUserID: Storage.getCookie(Enums.Cookie.userID),
        // ID: Helper.emptyGuid(),
        ConfigurationType: type,
        ConfigurationSection: section,
        MetaData: JSON.stringify({}),
        IsActive: true
    };
};

const saveTimeouts = new Map<string, ReturnType<typeof setTimeout>>();

const saveConfigDebounced = (config: any, delay = 500) => {
    const key = `${config?.ConfigurationType}|${config?.ConfigurationSection}`;
    clearTimeout(saveTimeouts.get(key));
    saveTimeouts.set(key, setTimeout(async () => {
        saveTimeouts.delete(key);
        await saveConfig(config);
    }, delay));
};

const saveConfig = async (config: any) => {
    let result = await Fetch.post({
        url: '/AuthUserConfiguration',
        params: config
    });

    return result;
};

const getMetaDataValue = (config: any, property: any) => {
    if (config && config.MetaData) {
        return JSON.parse(config.MetaData)[property] ?? null
    }
    return null;
};

const setMetaDataValue = (config: any, property: any, value: any) => {
    if (config && config.MetaData) {
        let meta = JSON.parse(config.MetaData);
        meta[property] = value;
        config.MetaData = JSON.stringify(meta);
    }
};


const updateFilters = (config: any, activeFilterIDs: any, ancillaryFilters: any, sortExpression: any, sortDirection: any, allowStickySort = false) => {
    if (activeFilterIDs) {
        setMetaDataValue(config, "ActiveFilterIDs", activeFilterIDs);
    } else {
        setMetaDataValue(config, "ActiveFilterIDs", {});
    }

    if (ancillaryFilters) {
        setMetaDataValue(config, "AncillaryFilters", ancillaryFilters);
    } else {
        setMetaDataValue(config, "AncillaryFilters", {});
    }

    if (allowStickySort && sortExpression) {
        setMetaDataValue(config, "SortExpression", sortExpression);
    } else {
        setMetaDataValue(config, "SortExpression", "");
    }

    if (allowStickySort && sortDirection) {
        setMetaDataValue(config, "SortDirection", sortDirection);
    } else {
        setMetaDataValue(config, "SortDirection", "");
    }
};

const getFilterValues = (config: any, activeFilterIDPropertyList = [], activeFilterIDDefault = [],
    ancillaryFilterPropertyList = [], ancillaryFilterDefault = false, allowStickySort = false) => {
    let activeFilterIDs = getMetaDataValue(config, "ActiveFilterIDs");
    let ancillaryFilters = getMetaDataValue(config, "AncillaryFilters");

    let stickyFilters = true;
    // if ((ancillaryFilterPropertyList && ancillaryFilterPropertyList.includes("StickyFilters")) || (ancillaryFilters && ancillaryFilters.StickyFilters !== undefined)) {
    //     stickyFilters = !ancillaryFilters || ancillaryFilters.StickyFilters !== false;

    let stickySorting = false;
    // if ((ancillaryFilterPropertyList && ancillaryFilterPropertyList.includes("StickySorting")) || (ancillaryFilters && ancillaryFilters.StickySorting !== undefined)) {

    if (activeFilterIDPropertyList) {
        activeFilterIDs = activeFilterIDs !== undefined && activeFilterIDs !== null ? activeFilterIDs : {};
        activeFilterIDPropertyList.map((prop: any) => {
            activeFilterIDs[prop] = activeFilterIDs[prop] !== undefined && stickyFilters ? activeFilterIDs[prop] : activeFilterIDDefault;
            if (prop === "DateRange" && activeFilterIDs[prop].length === 0) {
                activeFilterIDs[prop] = [null, null];
            }
        });
    }

    if (!ancillaryFilterPropertyList) {
        ancillaryFilterPropertyList = [];
    }

    if (ancillaryFilterPropertyList) {
        ancillaryFilters = ancillaryFilters !== undefined && ancillaryFilters !== null ? ancillaryFilters : {};
        ancillaryFilterPropertyList.map((prop: any) => {
            let defaultVal = ancillaryFilterDefault;
            if (prop === "StickyFilters") {
                defaultVal = true;
            }
            let isStickySetting = prop === "StickyFilters" || prop === "StickySorting";
            ancillaryFilters[prop] = ancillaryFilters[prop] !== undefined && (stickyFilters || isStickySetting) ? ancillaryFilters[prop] : defaultVal;
        });
    }

    let sortExpression = !allowStickySort || !stickySorting ? "" : getMetaDataValue(config, "SortExpression");
    let sortDirection = !allowStickySort || !stickySorting ? "" : getMetaDataValue(config, "SortDirection");

    return [activeFilterIDs, ancillaryFilters, sortExpression, sortDirection];
};


const setAppointmentDefaultPage = async (defaultPage: any) => {
    const filtersConfig = await getPageFilters(Enums.ConfigurationSection.Appointment);

    let activeFilterIDs = getMetaDataValue(filtersConfig, "ActiveFilterIDs");
    if (activeFilterIDs == null) {
        activeFilterIDs = {};
    }
    activeFilterIDs.DefaultPage = [defaultPage];
    setMetaDataValue(filtersConfig, "ActiveFilterIDs", activeFilterIDs);

    let result = await Fetch.post({
        url: '/AuthUserConfiguration',
        params: filtersConfig
    });
    return result;
};

const getAlternateDashboardLayout = async () => {
    let flagResponse = await Fetch.get({
        url: '/AuthUserConfiguration/AuthUserFlags',
    });

    return flagResponse.ShowDashboard;
};

const getLegacyDashboardLayout = async () => {
    let optionResponse = await Fetch.get({
        url: '/Option/GetByOptionName',
        params: {
            name: "Legacy Dashboard"
        }
    });

    return Helper.parseBool(optionResponse);
}

const getPreTrialDashboardDismissed = (filtersConfig: any) => {
    let list = getMetaDataValue(filtersConfig, "PreTrialDashboardDismissed");

    if (list == null) {
        return [];
    } else {
        return list;
    }
};

const setPreTrialDashboardDismissed = (filtersConfig: any, newList: any) => {
    setMetaDataValue(filtersConfig, "PreTrialDashboardDismissed", newList);
}

const getSCDashboardPageConfig = (filtersConfig: any) => {
    let dashboardPageConfig = getMetaDataValue(filtersConfig, "DashboardPageConfig");
    return dashboardPageConfig;
};

const setSCDashboardPageConfig = (filtersConfig: any, dashboardPageConfig: any) => {
    setMetaDataValue(filtersConfig, "DashboardPageConfig", dashboardPageConfig);
}

export default {
    getSettings,
    getPageFilters,
    getCrudSettings,
    saveConfig,
    getMetaDataValue,
    setMetaDataValue,
    updateFilters,
    getFilterValues,
    saveConfigDebounced,
    setAppointmentDefaultPage,
    getAlternateDashboardLayout,
    getPreTrialDashboardDismissed,
    setPreTrialDashboardDismissed,
    getSCDashboardPageConfig,
    setSCDashboardPageConfig,
    getLegacyDashboardLayout
};
